import { useContext } from "@wordpress/element";
import icons from '../../../options/icons';
import BlockContext from '../context/blockContext';
function SocialIcon() {
	const { attributes } = useContext(BlockContext);
	const { socialIcon } = attributes;
  return (
    <div className="social-icon">
        {socialIcon?.map((item, index) => (
            item.link ? (
              <a key={index} href={item.link} target="_blank" rel="noopener noreferrer">
                <span className="icon">{icons[item.icon]}</span>
              </a>
            ) : (
              <span key={index} className="icon disabled">
                {icons[item.icon]}
              </span>
            )
          ))}
    </div>
  )
}

export default SocialIcon
